export type StartDate = string
export type EndOfWritingPeriod = string

export type WritingPeriod = {
  startDate: StartDate
  endOfWritingPeriod: EndOfWritingPeriod
}

const startDates: WritingPeriod[] = [
  {
    endOfWritingPeriod: '1/10/24',
    startDate: '1/16/24',
  },
  {
    endOfWritingPeriod: '1/23/24',
    startDate: '1/29/24',
  },
  {
    endOfWritingPeriod: '2/13/24',
    startDate: '2/19/24',
  },
  {
    endOfWritingPeriod: '2/27/24',
    startDate: '3/4/24',
  },
  {
    endOfWritingPeriod: '3/19/24',
    startDate: '3/25/24',
  },
  {
    endOfWritingPeriod: '4/2/24',
    startDate: '4/8/24',
  },
  {
    endOfWritingPeriod: '4/23/24',
    startDate: '4/29/24',
  },
  {
    endOfWritingPeriod: '5/7/24',
    startDate: '5/13/24',
  },
  {
    endOfWritingPeriod: '5/28/24',
    startDate: '6/3/24',
  },
  {
    endOfWritingPeriod: '6/11/24',
    startDate: '6/17/24',
  },
  {
    endOfWritingPeriod: '7/2/24',
    startDate: '7/8/24',
  },
  {
    endOfWritingPeriod: '7/16/24',
    startDate: '7/22/24',
  },
  {
    endOfWritingPeriod: '8/6/24',
    startDate: '8/12/24',
  },
  {
    endOfWritingPeriod: '8/20/24',
    startDate: '8/26/24',
  },
  {
    endOfWritingPeriod: '9/10/24',
    startDate: '9/16/24',
  },
  {
    endOfWritingPeriod: '9/24/24',
    startDate: '9/30/24',
  },
  {
    endOfWritingPeriod: '10/15/24',
    startDate: '10/21/24',
  },
  {
    endOfWritingPeriod: '10/29/24',
    startDate: '11/4/24',
  },
  {
    endOfWritingPeriod: '11/19/24',
    startDate: '11/25/24',
  },
  {
    endOfWritingPeriod: '12/3/24',
    startDate: '12/9/24',
  },
  {
    endOfWritingPeriod: '1/7/25',
    startDate: '1/13/25',
  },
  {
    endOfWritingPeriod: '1/21/25',
    startDate: '1/27/25',
  },
  {
    endOfWritingPeriod: '2/11/25',
    startDate: '2/17/25',
  },
  {
    endOfWritingPeriod: '2/25/25',
    startDate: '3/3/25',
  },
  {
    endOfWritingPeriod: '3/18/25',
    startDate: '3/24/25',
  },
  {
    endOfWritingPeriod: '4/1/25',
    startDate: '4/7/25',
  },
  {
    endOfWritingPeriod: '4/22/25',
    startDate: '4/28/25',
  },
  {
    endOfWritingPeriod: '5/6/25',
    startDate: '5/12/25',
  },
  {
    endOfWritingPeriod: '5/27/25',
    startDate: '6/2/25',
  },
  {
    endOfWritingPeriod: '6/10/25',
    startDate: '6/16/25',
  },
  {
    endOfWritingPeriod: '7/1/25',
    startDate: '7/7/25',
  },
  {
    endOfWritingPeriod: '7/15/25',
    startDate: '7/21/25',
  },
  {
    endOfWritingPeriod: '8/5/25',
    startDate: '8/11/25',
  },
  {
    endOfWritingPeriod: '8/19/25',
    startDate: '8/25/25',
  },
  {
    endOfWritingPeriod: '9/9/25',
    startDate: '9/15/25',
  },
  {
    endOfWritingPeriod: '9/23/25',
    startDate: '9/29/25',
  },
  {
    endOfWritingPeriod: '10/14/25',
    startDate: '10/20/25',
  },
  {
    endOfWritingPeriod: '10/28/25',
    startDate: '11/3/25',
  },
  {
    endOfWritingPeriod: '11/18/25',
    startDate: '11/24/25',
  },
  {
    endOfWritingPeriod: '12/2/25',
    startDate: '12/8/25',
  },
]

export default startDates
